/* ============================================
   Copiar al portapapeles con respaldo.
   `navigator.clipboard` falla en contextos no seguros (http), en webviews y
   cuando el navegador no considera que hubo gesto del usuario. En esos casos
   caemos al textarea + execCommand, que sigue funcionando en todos lados.
   ============================================ */

export async function copiarTexto(texto: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(texto)
      return true
    }
  } catch {
    // sigue al respaldo
  }

  try {
    const ta = document.createElement('textarea')
    ta.value = texto
    // Fuera de vista pero seleccionable; readOnly evita que salte el teclado en móvil.
    ta.setAttribute('readonly', '')
    ta.style.position = 'fixed'
    ta.style.top = '-1000px'
    ta.style.opacity = '0'
    document.body.appendChild(ta)
    ta.select()
    ta.setSelectionRange(0, texto.length)
    const ok = document.execCommand('copy')
    document.body.removeChild(ta)
    return ok
  } catch {
    return false
  }
}
